import { render, staticRenderFns } from "./DriveFolderRenamed.vue?vue&type=template&id=2dc0e9da&scoped=true"
import script from "./DriveFolderRenamed.vue?vue&type=script&lang=js"
export * from "./DriveFolderRenamed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc0e9da",
  null
  
)

export default component.exports